import "./pages.css";

export const Private3 = () => {
    return(
        <h1 className="content">
            PRIVATE PAGE 3
        </h1>
    );
}